export const PROVIDER_TRUEMED = 'TRUEMED';